export const lmp_quote = {
  policy: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '2311 CENTRAL ST',
      line_two: 'Apt 2',
      city: 'EVANSTON',
      state: 'IL',
      zip_code: '60201',
    },
  },
  quote_metadata: {
    campaign_medium: 'Lorem ad exercitation',
    campaign_name: 'ABC123',
    quote_identifier: '54asdf54asd5f4a5s4df',
    quote_name: 'Basic',
    partner_unstructured_metadata: {},
  },
  vehicles: [
    {
      vehicle_identification: {
        vin: '5FNRL5H64GB111411',
      },
      mileage: {
        annual: 18000,
      },
      ownership_type: 'owned',
      vehicle_usage: 'commute',
      is_used_for_rideshare: false,
      anti_theft: ['none'],
      vehicle_coverages: {
        comprehensive: {
          deductible_key: 'one_hundred',
        },
        collision: {
          deductible_key: 'one_hundred',
        },
        rental: {
          limit_key: 'fifty_fifteen_hundred',
        },
        roadside: {
          waived: false,
        },
        rideshare: {
          waived: true,
        },
        uninsured_motorist_property_damage: {
          waived: true,
        },
      },
    },
  ],
  current_policy: {
    proof_of_insurance: true,
    carrier_name: 'state_farm',
    state: 'CO',
    policy_start_date: '2017-09-01',
    policy_end_date: '2018-05-01',
    term_in_months: 6,
    customer_loyalty_in_months: 120,
    policy: {
      coverages: {
        bodily_injury: {
          limit_enum: 'fifty_one_hundred',
        },
      },
    },
    insurance_status: {
      is_currently_insured: true,
    },
    drivers: [
      {
        driver_information: {
          first_name: 'Charles',
          last_name: 'Boyce',
          relationship_to_applicant: 'applicant',
        },
      },
    ],
  },
  drivers: [
    {
      exclude_from_quote: false,
      contact_information: {
        phone_numbers: [
          {
            number: '5555555555',
            type: 'home',
          },
        ],
      },
      driver_information: {
        first_name: 'Charles',
        last_name: 'Boyce',
        date_of_birth: '1930-12-16',
        gender: 'male',
        marital_status: 'single',
        relationship_to_applicant: 'applicant',
      },
      current_education: {
        education_level_clearcover_key: 'bachelors_degree',
      },
      license: {
        region: 'usa',
        age_first_licensed: 16,
        status: 'active',
        state: 'CO',
        number: '885381229',
        source: 'user_reported',
        has_previous_suspension: false,
      },
      homeownership: {
        homeowner: true,
        months_owned: 16,
      },
      traffic_school: {
        course_taken: false,
      },
      occupation: {
        occupation_clearcover_key:
          'Nursing Instructors and Teachers, Postsecondary',
      },

      military_service: {
        is_deployed: false,
        service_member: true,
        military_grade: 'O-4',
      },
    },
  ],
};

export const one_inc_3_quote = {
  policy: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '426 Ennisbrook Dr',
      city: 'Santa Barbara',
      state: 'CA',
      zip_code: '95630',
    },
  },
  quote_metadata: {
    campaign_medium: 'Lorem ad exercitation',
    campaign_name: 'ABC123',
    quote_identifier: '54asdf54asd5f4a5s4df',
    quote_name: 'Basic',
    partner_unstructured_metadata: {},
  },
  vehicles: [
    {
      vehicle_identification: {
        vin: '5FNRL5H64GB111411',
      },
      mileage: {
        annual: 18000,
      },
      ownership_type: 'owned',
      vehicle_usage: 'commute',
      is_used_for_rideshare: false,
      anti_theft: ['none'],
      vehicle_coverages: {
        comprehensive: {
          deductible_key: 'one_hundred',
        },
        collision: {
          deductible_key: 'one_hundred',
        },
        rental: {
          limit_key: 'fifty_fifteen_hundred',
        },
        roadside: {
          waived: false,
        },
        rideshare: {
          waived: true,
        },
        uninsured_motorist_property_damage: {
          waived: true,
        },
      },
    },
  ],
  current_policy: {
    proof_of_insurance: true,
    carrier_name: 'state_farm',
    state: 'CO',
    policy_start_date: '2017-09-01',
    policy_end_date: '2018-05-01',
    term_in_months: 6,
    customer_loyalty_in_months: 120,
    policy: {
      coverages: {
        bodily_injury: {
          limit_enum: 'fifty_one_hundred',
        },
      },
    },
    insurance_status: {
      is_currently_insured: true,
    },
    drivers: [
      {
        driver_information: {
          first_name: 'Charles',
          last_name: 'Boyce',
          relationship_to_applicant: 'applicant',
        },
      },
    ],
  },
  drivers: [
    {
      exclude_from_quote: false,
      contact_information: {
        phone_numbers: [
          {
            number: '5555555555',
            type: 'home',
          },
        ],
      },
      confirmed_no_accidents: true,
      confirmed_no_violations: true,
      driver_information: {
        first_name: 'Charles',
        last_name: 'Boyce',
        date_of_birth: '1930-12-16',
        gender: 'male',
        marital_status: 'single',
        relationship_to_applicant: 'applicant',
      },
      current_education: {
        education_level_clearcover_key: 'bachelors_degree',
      },
      license: {
        region: 'usa',
        age_first_licensed: 16,
        status: 'active',
        state: 'CO',
        number: '885381229',
        source: 'user_reported',
        has_previous_suspension: false,
      },
      homeownership: {
        homeowner: true,
        months_owned: 16,
      },
      traffic_school: {
        course_taken: false,
      },
      occupation: {
        occupation_clearcover_key:
          'Nursing Instructors and Teachers, Postsecondary',
      },

      military_service: {
        is_deployed: false,
        service_member: true,
        military_grade: 'O-4',
      },
    },
  ],
};

export const core_quote = {
  policy: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '5840 ADAMS ST',
      line_two: 'Apt 2',
      city: 'Lincoln',
      state: 'NE',
      zip_code: '68507',
    },
  },
  quote_metadata: {
    campaign_medium: 'Lorem ad exercitation',
    campaign_name: 'ABC123',
    quote_identifier: '54asdf54asd5f4a5s4df',
    quote_name: 'Basic',
    partner_unstructured_metadata: {},
  },
  vehicles: [
    {
      vehicle_identification: {
        vin: '5FNRL5H64GB111411',
      },
      mileage: {
        annual: 18000,
      },
      ownership_type: 'owned',
      vehicle_usage: 'commute',
      is_used_for_rideshare: false,
      anti_theft: ['none'],
      vehicle_coverages: {
        comprehensive: {
          deductible_key: 'one_hundred',
        },
        collision: {
          deductible_key: 'one_hundred',
        },
        rental: {
          limit_key: 'fifty_fifteen_hundred',
        },
        roadside: {
          waived: false,
        },
        rideshare: {
          waived: true,
        },
        uninsured_motorist_property_damage: {
          waived: true,
        },
      },
    },
  ],
  current_policy: {
    proof_of_insurance: true,
    carrier_name: 'state_farm',
    state: 'CO',
    policy_start_date: '2017-09-01',
    policy_end_date: '2018-05-01',
    term_in_months: 6,
    customer_loyalty_in_months: 120,
    policy: {
      coverages: {
        bodily_injury: {
          limit_enum: 'fifty_one_hundred',
        },
      },
    },
    insurance_status: {
      is_currently_insured: true,
    },
    drivers: [
      {
        driver_information: {
          first_name: 'Anette',
          last_name: 'Boswell',
          relationship_to_applicant: 'applicant',
        },
      },
    ],
  },
  drivers: [
    {
      exclude_from_quote: false,
      contact_information: {
        phone_numbers: [
          {
            number: '5555555555',
            type: 'home',
          },
        ],
      },
      confirmed_no_accidents: true,
      confirmed_no_violations: true,
      driver_information: {
        first_name: 'TAMMY',
        last_name: 'BEHNER',
        date_of_birth: '1975-10-08',
        gender: 'female',
        marital_status: 'single',
        relationship_to_applicant: 'applicant',
      },
      current_education: {
        education_level_clearcover_key: 'bachelors_degree',
      },
      license: {
        region: 'usa',
        age_first_licensed: 16,
        status: 'active',
        state: 'NE',
        number: 'G20011031',
        source: 'user_reported',
        has_previous_suspension: false,
      },
      homeownership: {
        homeowner: true,
        months_owned: 16,
      },
      traffic_school: {
        course_taken: false,
      },
      occupation: {
        occupation_clearcover_key:
          'Nursing Instructors and Teachers, Postsecondary',
      },

      military_service: {
        is_deployed: false,
        service_member: true,
        military_grade: 'O-4',
      },
    },
  ],
};
